import React from "react";
import "./WidgetLoader.css";

/**
 * A reusable component for displaying loading state in widgets with pulsating animation
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isLoading - Whether the widget content is currently loading
 * @param {string} props.message - Optional message to display during loading (shows spinner if not provided)
 * @param {string} props.className - Additional classes to add to the wrapper
 * @param {boolean} props.compact - Whether to use compact styling for smaller widgets
 * @param {React.ReactNode} props.children - Widget content to display when not loading
 * @returns {JSX.Element} The rendered component
 */
const WidgetLoader = ({
  isLoading,
  message,
  className = "",
  compact = false,
  children,
}) => {
  return (
    <div
      className={`WidgetLoader-wrapper ${isLoading ? "loading" : ""} ${
        compact ? "compact" : ""
      } ${className}`}
      data-message={message}
    >
      {children}
    </div>
  );
};

export default WidgetLoader;
